<template>
  <div>
    <div class="header-style">
      <div @click="messageBut" class="prompt">
        <span class="icon">
          <van-icon name="bell" />
        </span>
        <span v-if="notReadMsgCount && bellNum > 0" class="point"></span>
      </div>
      <div class="header-title">智慧校园</div>
      <div class="icon" @click="showUserInfo">
        <i class="iconfont">&#xe6fe;</i>
        <!-- <img class="iconImg" v-if="userInfo.Icon" :src="require(imgHost +userInfo.IconFull)" alt />
        <img class="iconImg" v-else src="../../../../assets/basic/yrykb.png" alt="avatar" />-->
      </div>
    </div>
    <div class="common-top">
      <div class="common-title">常用工具</div>
      <div>
        <ul class="common-ul">
          <li v-for="(item, index) in list" :key="index" @click="goModule(item)">
            <div class="common-img">
              <img :src="require('@/assets/moduleIcon/' + item.Icon)" alt />
            </div>
            <div class="common-name">{{ item.Name }}</div>
          </li>
          <li @click="moreBtn">
            <div class="common-img">
              <img :src="require('@/assets/common/listMore.png')" alt />
            </div>
            <div class="common-name">更多</div>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="SelfMessageList.length > 0" class="message-img">
      <!-- <img src="@/assets/common/message.png" alt /> -->
      <div class="message-title">消息通知</div>
      <div class="message-tip">
        <van-icon name="volume-o" /><span>{{ isNoRead ? '您有未读消息' : '暂无新消息' }}</span>
      </div>
    </div>
    <div
      v-show="SelfMessageList.length !== 0"
      class="news-list"
      v-for="item in SelfMessageList"
      :key="item.MessageID"
    >
      <div class="news-item" :class="{ isRead: item.Status === 1 }">
        <messageCard
          :SelfMessageList="item"
          :pathSource="pathSource"
          :msgInfoNullShowFn="msgInfoNullShowFn"
        />
      </div>
    </div>

    <div class="no-msg-box" v-if="msgInfoNull">
      <div class="no-msg-content">
        <img src="../../../../assets/basic/noMsgImg.png" />
        <div class="no-msg-box-text">
          <div>暂无消息</div>
          <p>在PC端相应模块内可查找到消息详情</p>
        </div>
        <div class="no-msg-box-button" @click="msgInfoNull = false">我知道了</div>
      </div>
    </div>

    <div class="message-info">
      <div class="message-null" v-if="SelfMessageList.length === 0">
        <div class="message-null-img">
          <img :src="require('@/assets/common/nullinfo.png')" alt />
        </div>
        <div>暂无消息</div>
      </div>
      <div class="message-null index-footer" v-else>已经到达最底部</div>
    </div>
    <van-popup
      class="pop-module"
      v-model="showSideBar"
      position="right"
      :style="{ width: '60%', height: '100%' }"
    >
      <div class="user">
        <img class="iconImg" v-if="userInfo.Icon" :src="userInfo.IconFull" alt />
        <img class="iconImg" v-else src="../../../../assets/basic/yrykb.png" alt="avatar" />
        <p class="drawer-name">{{ userInfo.FullName }}</p>
        <p class="drawer-id">{{ userInfo.SchoolCardNumber }}</p>
      </div>
      <ul class="drawer-ul">
        <li @click="resetPassword">
          <i class="fa fa-unlock-alt" aria-hidden="true"></i>
          <span>修改密码</span>
        </li>
        <li @click="loginOut">
          <i class="fa fa-sign-out"></i>
          <span>退出登录</span>
        </li>
      </ul>
    </van-popup>
  </div>
</template>
<script>
  import messageCard from '@/pages/common/views/message/components/messageCard.vue'

  export default {
    name: 'gateway',
    data() {
      return {
        isNoRead: false,
        imgHost: this.xyMApi,
        list: [],
        userInfo: '',
        showSideBar: false,
        SelfMessageList: [],
        pageSize: 10,
        page: 1,
        pathSource: 'XyIndex',
        msgInfoNull: false,
        msgID: '',
        msgData: '',
        domainList: [],
        notReadMsgCount: false,
        bellNum: 0
      }
    },
    components: {
      messageCard
    },
    created() {
      if( localStorage.getItem("RouteUrl")){
      this.getMobileMoudle()
    }else{
      this.$store.commit('changeApiPublic', `${this.xyMApi}/approve`)
      this.isFromWeChartInfo();
      this.getFrequently();
      this.getUserInfo();
      this.getSelfMessage();
      this.getNoReadCountByUser();
    }
    },
    methods: {
      async isFromWeChartInfo() {
        this.msgID = window.localStorage.getItem('msgUrl')
        if (this.msgID !== 'undefined' && this.msgID !== null && this.msgID !== '') {
          let res = await this.xyapi.get(
            this.xyMApi + `/api/message/GetMessageByID?messageID=${this.msgID}`
          )
          if (res.success) {
            this.setMessageRead()
            let messageRow = res.data
            if (!messageRow.DetailMobileUrl) {
              this.goTuUrl(1)
            } else {
              // if (this.$store.apiPath !== messageRow.ServiceDoMainName) {
              //   this.$store.commit("changeApiPath", messageRow.ServiceDoMainName);
              // }
              this.$store.commit('changeMessageInfo', messageRow)
              // 消息路由跳转
              this.$router.push({
                path: messageRow.DetailMobileUrl,
                query: { fromMessage: true }
              })
              window.localStorage.setItem('msgUrl', '')
            }
          }
        }
      },
      // 设置消息已读
      async setMessageRead() {
        await this.xyapi.post(
          this.xyMApi + `/msg/api/message/SetStatus?messageID=${this.msgID}&status=1`
        )
      },
      goTuUrl(SourceType) {
        let MessageAppUrl = SourceType === 1 ? '' : this.SelfMessageList.WebDoMainName
        this.$router.push({
          path: '/messageDetail',
          query: {
            MessageModel: JSON.stringify(this.SelfMessageList),
            MessageAppUrl: MessageAppUrl,
            SourceType: SourceType,
            type: '0',
            pathSource: this.pathSource
          }
        })
      },
      goModule(vals) {
        if (vals.MobileUrl.indexOf('http://') > -1 ||vals.MobileUrl.indexOf('https://') > -1) {
          if (vals.IsExternal) {
              let urls = `${vals.MobileUrl}${vals.MobileUrl.indexOf('?') > -1 ? '&' : '?'}`
              let tokens = this.xy.getCookie(".XYTOKEN")
              let actumber =  window.localStorage.getItem("AccountNumber");
              window.open(`${urls}token=${tokens}&AccountNumber=${actumber}`)
              return
            }
        }else{
           this.$store.commit('changeApiPath', `${this.xyMApi}/${vals.ModuleCode}`)
          localStorage.setItem('breadcrumb', JSON.stringify(vals))
          if (vals.MobileUrl) {
            localStorage.setItem('navTitle', vals.Name)
            this.$router.push(vals.MobileUrl)
          } else {
            localStorage.setItem('navTitle', vals.subMenu[0].Name)
            this.$router.push(vals.subMenu[0].ApplicationSubMenuMobileUrl)
          }
          this.$store.commit('common/getMenuIDs', [vals.MID, vals.ID])
        }
      },
      resetPassword() {
        this.$router.push('/password')
      },
      loginOut() {
        this.$dialog
          .confirm({
            title: '退出',
            message: '您确定要退出登录吗？'
          })
          .then(() => {
            localStorage.clear()
            this.xy.removeCookie('.XYTOKEN')
            this.$router.push('/')
            document.title = '登录'
          })
          .catch(() => {})
      },

      showUserInfo() {
        this.showSideBar = true
      },
      async getFrequently() {
        this.xy.loading()
        this.list = []
        let res = await this.xyapi.get(`${this.xyMApi}/xy/comm/FrequentlyMobileApplications`)
        if (res.success) {
          this.list = res.data.Modules.slice(0, 7)
          this.domainList = res.data.ServiceDomains
          this.changeIpadPath(this.list)
        }
        this.xy.unloading()
      },
      changeIpadPath(list) {
        if (!window.isIpad || !list || !list.length) return
        let obj = list.find(i => i.Name === '课堂评价') || { subMenu: [] }



         obj.subMenu = obj.subMenu.filter(item => {
          return item.ApplicationSubMenuMobileUrl !== '/home/evaStatistics'
        })
        obj.subMenu.forEach(item => {
          if (item.ApplicationSubMenuMobileUrl === '/home/evaStudentWrap') {
            item.ApplicationSubMenuMobileUrl = '/ipad/EvaStudentWrap'
          }
          if (item.ApplicationSubMenuMobileUrl === '/home/evaMyeva') {
            item.ApplicationSubMenuMobileUrl = '/ipad/evaMyeva'
          }
        })
      },
      async getNoReadCountByUser() {
        let res = await this.xyapi.get(`${this.xyMApi}/msg/api/Message/GetNoReadCountByUser`, null)
        if (res.success) {
          this.notReadMsgCount = res.data.success
          if (this.notReadMsgCount) {
            this.bellNum = res.data.result
          } else {
            this.bellNum = 0
          }
          this.isNoRead = res.data.result > 0 ? true : false
        }
      },
      async getUserInfo() {
        let res = await this.xyapi.get(this.xyMApi + '/base/api/Users/CurUserInfo')
        if (res.success) {
          this.$store.commit('common/getUserInfo', res.data)
          this.userInfo = res.data
        } else {
          this.$notify.error(res.msg)
        }
      },
      moreBtn() {
        this.$router.push('/funclist')
      },
      messageBut() {
        this.$router.push('/messageList')
      },
      // 获取全部消息
      async getSelfMessage() {
        var params = {
          // -1全部消息，0未读消息，1已读消息
          status: -1,
          beginDate: '',
          endDate: '',
          pageIndex: this.page,
          pageSize: this.pageSize
        }
        let res = await this.xyapi.get(this.xyMApi + '/msg/api/Message/GetPageSelf', params)
        if (res && res.data && res.data.data) {
          this.SelfMessageList = res.data.data.slice(0, 7)
        }
      },
      msgInfoNullShowFn() {
        this.msgInfoNull = true
      },
      //直接登陆
    async getMobileMoudle() {
      
        this.list = [];
        this.domainList=[];
        this.xy.loading();
        let res = await this.xyapi.get(
          this.xyMApi + "/xy/comm/MobileMoudle"
        );
        let parentItem = ''
        let application = ''
        let subMenu = ''
        let RouteUrl=localStorage.getItem("RouteUrl")
        let moduleList = res.data.Modules
        for (let i = 0; i < moduleList.length; i++) {
          for (let m = 0; m < moduleList[i].applications.length; m++) {
            if (moduleList[i].applications[m].MobileUrl === RouteUrl) {
              parentItem = moduleList[i]
              application = moduleList[i].applications[m]
            } else {
              for (let n = 0; n < moduleList[i].applications[m].subMenu.length; n++) {
                if (moduleList[i].applications[m].subMenu[n].ApplicationSubMenuMobileUrl === RouteUrl) {
                  parentItem = moduleList[i]
                  application = moduleList[i].applications[m]
                  subMenu = moduleList[i].applications[m].subMenu[n]
                }
              }
            }
          }
        }
        this.$store.commit('changeApiPath', `${this.xyMApi}/${parentItem.ModuleCode}`)
        localStorage.setItem("breadcrumb", JSON.stringify(application));
        if(subMenu){
          this.$store.commit("common/getMenuIDs", [application.MID, application.ID,subMenu.ID]);
          localStorage.setItem("navTitle", subMenu.Name);
        }else{
          this.$store.commit("common/getMenuIDs", [application.MID, application.ID]);
          localStorage.setItem("navTitle", application.Name);
        }
        this.$router.push(RouteUrl);
        localStorage.removeItem("RouteUrl");
        // this.xy.unloading();
      }

    }
  }
</script>
<style lang="less" scoped>
  .pop-module {
    text-align: center;
    padding: 0 40px;
    .user {
      margin-top: 100px;
      .iconImg {
        width: 132px;
        height: 132px;
      }
      .drawer-name {
        font-size: 32px;
        margin-top: 10px;
      }
      .drawer-id {
        margin-top: 10px;
        font-size: 24px;
        color: #7f7f7f;
      }
    }
    .drawer-ul {
      margin-top: 40px;
      text-align: left;
      font-size: 32px;
      li {
        line-height: 80px;
      }
    }
  }
  .header-style {
    height: 80px;
    color: #333;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
    .header-title {
      font-size: 28px;
    }
    .icon {
      i {
        font-size: 30px;
      }
    }
  }
  .iconImg {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    border: 1px solid #ffffff;
  }
  .common-top {
    background: #ffffff;
    min-height: 360px;
    border-radius: 31px;
    margin: 20px;
    padding: 20px 0;
    box-shadow: 0px 4px 10px 0px rgba(151, 151, 151, 0.2);

    .common-title {
      font-size: 32px;
      color: #0a0a0a;
      padding: 0 20px 0;
    }

    .common-ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      li {
        text-align: center;
        width: 25%;
        margin-top: 32px;

        .common-img {
          img {
            width: 80px;
          }
        }

        .common-name {
          font-size: 24px;
        }
      }
    }
  }

  .message-img {
    width: 90%;
    height: 140px;
    margin: 0 auto;
    background-image: url(~@/assets/common/message.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding: 10px 0 0 100px;
    .message-title {
      font-size: 36px;
      color: #fff;
      font-weight: 500;
      margin-left: 60px;
    }
    .message-tip {
      display: flex;
      align-items: center;
      color: #ebbf4a;
      background: rgba(12, 24, 145, 0.2);
      width: 300px;
      padding: 2px 20px;
      margin-top: 10px;
      border-radius: 22px;
      span {
        margin-left: 10px;
      }
    }
  }

  .message-info {
    padding: 20px;

    .message-null {
      text-align: center;
      font-size: 28px;
      color: #7f7f7f;
      padding: 12px;
      border-radius: 32px;
      .message-null-img {
        width: 80%;
        margin: 20px auto 60px;
        img {
          width: 100%;
        }
      }
    }
    .index-footer {
      background-color: transparent;
      color: #8989a9;
    }
  }
  .no-msg-box {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: #fff;
    z-index: 10;
    .no-msg-content {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      text-align: center;
      img {
        margin-top: 228px;
        width: 374px;
        height: 264px;
      }
      .no-msg-box-text {
        width: 100%;
        padding-top: 51px;
        font-size: 30px;
        font-family: 'Hiragino Sans GB';
        color: rgba(17, 17, 17, 1);
        p {
          font-size: 28px;
          color: rgba(72, 120, 227, 1);
          padding-top: 23px;
        }
      }
      .no-msg-box-button {
        width: 280px;
        height: 64px;
        line-height: 64px;
        margin-top: 211px;
        border-radius: 32px;
        background: #4196ff;
        color: #fff;
        font-size: 30px;
      }
    }
  }
  .prompt {
    position: relative;
    .point {
      position: absolute;
      top: 0px;
      right: -2px;
      padding: 6px;
      background-color: #ef4f4f;
      color: #fff;
      border-radius: 50%;
    }
  }
</style>
